import {lazy} from 'react';
import {useSelector} from 'react-redux';
import {selectUserOrSystemDisabled} from '~/common/fabric/GiftCard/reducers/eGiftCard';
import {EventReviewWrapper} from '~/common/fabric/routes/EventReview/EventReviewWrapper';

const GiftCardReview = lazy(() =>
  import('./GiftCardReview').then((module) => ({default: module.GiftCardReview}))
);

export const Review = () => {
  const isGiftCard = !useSelector(selectUserOrSystemDisabled);
  return isGiftCard ? <GiftCardReview /> : <EventReviewWrapper />;
};
